import { useState } from "@wordpress/element";
import { Button } from "../../../_form/button";

export function Accordion({ position, children }) {
	const [open, setOpen] = useState(false);

	return (
		<div
			className="wp-block-steam-blocks-vacancies__accordion"
			data-open={open}
		>
			<button
				onClick={() => setOpen((p) => !p)}
				className="wp-block-steam-blocks-vacancies__toggle has-body-lg-font-size"
			>
				{position.title}
			</button>

			<div className="wp-block-steam-blocks-vacancies__accordion-content">
				{children}
			</div>
		</div>
	);
}
